/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Meta_Shown_Decks_PartialInputs */



/**
* | totalPlural | output |
* | --- | --- |
* | "one" | "{shownFormatted} of {totalFormatted} archived deck" |
* | * | "{shownFormatted} of {totalFormatted} archived decks" |
*
* @param {Meta_Shown_Decks_PartialInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_shown_decks_partial = /** @type {((inputs: Meta_Shown_Decks_PartialInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Shown_Decks_PartialInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const totalPlural = registry.plural("de", i?.total, {}, true);
		const shownFormatted = registry.number("de", i?.shown, {}, true);
		const totalFormatted = registry.number("de", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${shownFormatted} von ${totalFormatted} Deck im Archiv`);
		return /** @type {LocalizedString} */ (`${shownFormatted} von ${totalFormatted} Decks im Archiv`)
	}
	if (locale === "fr") {
		const totalPlural = registry.plural("fr", i?.total, {}, true);
		const shownFormatted = registry.number("fr", i?.shown, {}, true);
		const totalFormatted = registry.number("fr", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${shownFormatted} sur ${totalFormatted} deck archivé`);
		return /** @type {LocalizedString} */ (`${shownFormatted} sur ${totalFormatted} decks archivés`)
	}
	if (locale === "zh-Hans") {
		const totalPlural = registry.plural("zh-Hans", i?.total, {}, true);
		const shownFormatted = registry.number("zh-Hans", i?.shown, {}, true);
		const totalFormatted = registry.number("zh-Hans", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 份归档卡组中的 ${shownFormatted} 份`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 份归档卡组中的 ${shownFormatted} 份`)
	}
	if (locale === "zh-Hant") {
		const totalPlural = registry.plural("zh-Hant", i?.total, {}, true);
		const shownFormatted = registry.number("zh-Hant", i?.shown, {}, true);
		const totalFormatted = registry.number("zh-Hant", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 份已收錄牌組中的 ${shownFormatted} 份`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 份已收錄牌組中的 ${shownFormatted} 份`)
	}
	if (locale === "ko") {
		const totalPlural = registry.plural("ko", i?.total, {}, true);
		const shownFormatted = registry.number("ko", i?.shown, {}, true);
		const totalFormatted = registry.number("ko", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`보관된 덱 ${totalFormatted}개 중 ${shownFormatted}개`);
		return /** @type {LocalizedString} */ (`보관된 덱 ${totalFormatted}개 중 ${shownFormatted}개`)
	}
	{
		const totalPlural = registry.plural("en", i?.total, {}, true);
		const shownFormatted = registry.number("en", i?.shown, {}, true);
		const totalFormatted = registry.number("en", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${shownFormatted} of ${totalFormatted} archived deck`);
		return /** @type {LocalizedString} */ (`${shownFormatted} of ${totalFormatted} archived decks`)
	}
});